import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container" }

import { ref, watch } from 'vue'

import { Primitive, PrimitiveNonNull } from '@/models/common'

import EditableTableColumn from './EditableTableColumn.vue'

type SingleValue = string | number | boolean | ''
type Value = SingleValue | SingleValue[]

interface Props {
  sourceValue: SingleValue | SingleValue[] | null
  success: boolean
  loading?: boolean
  filterable?: boolean
  editable?: boolean
  options: Array<{ label: string; value: PrimitiveNonNull }>
  multiple?: boolean
  formatter?: (value: Primitive | Primitive[]) => string
}

interface Emits {
  (e: 'save', value: PrimitiveNonNull | PrimitiveNonNull[]): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EditableSelect',
  props: {
    sourceValue: { type: [String, Number, Boolean, Array, null] },
    success: { type: Boolean },
    loading: { type: Boolean, default: false },
    filterable: { type: Boolean, default: false },
    editable: { type: Boolean, default: true },
    options: {},
    multiple: { type: Boolean, default: false },
    formatter: {}
  },
  emits: ["save"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const isEditingMode = ref(false)

const getInitialValue = () => {
  if (props.sourceValue === null) {
    return props.multiple ? [] : ''
  }
  return props.sourceValue
}

const value = ref<Value>(getInitialValue())

watch(
  () => props.sourceValue,
  newValue => {
    value.value = newValue === null ? (props.multiple ? [] : '') : newValue
  }
)

watch(
  () => props.success,
  (newValue, prevValue) => {
    // changed from `false` to `true` means that updating action was success
    if (!prevValue && newValue) isEditingMode.value = false
  }
)

const handleEditPress = () => {
  isEditingMode.value = true
}

// const handleSavePress = () => {
//   if (!value.value && !props.multiple) return
//   emit('save', value.value as PrimitiveNonNull | PrimitiveNonNull[])
// }

const handleSavePress = () => {
  if (
    (value.value === '' || value.value === null || value.value === undefined) &&
    !props.multiple
  )
    return
  emit('save', value.value as PrimitiveNonNull | PrimitiveNonNull[])
}

const handleCancelPress = () => {
  isEditingMode.value = false
  value.value = getInitialValue()
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(EditableTableColumn, {
      editable: _ctx.editable,
      sourceValue: _ctx.sourceValue,
      formatter: _ctx.formatter,
      saveDisabled: value.value === '' || value.value === null || value.value === undefined,
      saveLoading: _ctx.loading,
      isEditingMode: isEditingMode.value,
      onEditClick: handleEditPress,
      onSaveClick: handleSavePress,
      onCancelClick: handleCancelPress
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_select, {
          modelValue: value.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
          placeholder: "Select",
          filterable: _ctx.filterable,
          multiple: _ctx.multiple,
          style: {"width":"80%"},
          clearable: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "filterable", "multiple"])
      ]),
      _: 1
    }, 8, ["editable", "sourceValue", "formatter", "saveDisabled", "saveLoading", "isEditingMode"])
  ]))
}
}

})